import { useState, useEffect, useMemo } from 'react';
import { ColumnConfig } from './types';

export function useColumnVisibility<T>(columns: ColumnConfig<T>[], controlledSelectedColumns?: string[], onSelectColumns?: (columns: string[]) => void) {
  const allColumnLabels = useMemo(() => columns.map((col) => col.label), [columns]);

  const [internalSelected, setInternalSelected] = useState<string[]>(allColumnLabels);

  // Sync internal state when columns change (e.g. translations load)
  useEffect(() => {
    if (!controlledSelectedColumns) {
      setInternalSelected(allColumnLabels);
    }
  }, [allColumnLabels, controlledSelectedColumns]);

  const selectedColumns = controlledSelectedColumns || internalSelected;

  const handleSelectColumns = (cols: string[]) => {
    if (onSelectColumns) {
      onSelectColumns(cols);
    } else {
      setInternalSelected(cols);
    }
  };

  const visibleColumns = useMemo(() => columns.filter((col) => selectedColumns.includes(col.label)), [columns, selectedColumns]);

  return { selectedColumns, handleSelectColumns, visibleColumns, allColumnLabels };
}
